import React, { FC, ReactNode } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { useModal } from '@shared/lib';
import { SearchIcon } from '@shared/assets/icons';
import { ModalProps } from '@shared/ui/organisms';
import { Text } from '@shared/ui/atoms';
import { homeSearchClickGtm } from '@shared/lib/gtm/redesign';
import SearchModalMobile from './SearchModalMobile';
type SuggestModalProps = ModalProps;
interface SearchInputButtonProps {
  renderSuggestModal: (props: SuggestModalProps) => ReactNode;
}
const SearchInputButton: FC<SearchInputButtonProps> = ({
  renderSuggestModal
}) => {
  const {
    isModalActive,
    handleModalClose,
    handleModalOpen
  } = useModal();
  return <>
      <SearchInputButtonWrapper onClick={() => {
      homeSearchClickGtm();
      handleModalOpen();
    }}>
        <IconWrapper>
          <SearchIcon />
        </IconWrapper>
        <Text size="captionL" color="secondary">
          Fortnite...
        </Text>
      </SearchInputButtonWrapper>
      <SearchModalMobile open={isModalActive} onClose={handleModalClose} renderSuggestModal={renderSuggestModal} />
    </>;
};
export default SearchInputButton;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.stroke.default;
const SearchInputButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "SearchInputButtonWrapper",
  class: "s17be2rv",
  propsAsIs: false,
  vars: {
    "s17be2rv-0": [_exp()]
  }
}));
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.secondary;
const IconWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i1ieus16",
  propsAsIs: false,
  vars: {
    "i1ieus16-0": [_exp2()]
  }
}));

require("./SearchInputButton.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SearchInputButton.tsx");